import React from 'react';
import { Typography, Box, Link } from '@mui/material';
import { useTenant } from 'src/contexts/TenantContext';

const getLink = (linkText: string, link: string) => {
  if (!linkText) return null;

  if (!link) {
    return <>{linkText}</>;
  }

  return (
    <Link
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: 'primary.main',
        textDecoration: 'none',
        transition: 'color 0.2s ease',
        '&:hover': {
          color: 'primary.main',
          textDecoration: 'underline',
        },
      }}
    >
      {linkText}
    </Link>
  );
};

const DisclosureText: React.FC = () => {
  const { getConfigValue } = useTenant();
  const privacyLink = getConfigValue<string>('PRIVACY_POLICY_URL', '');
  const termsLink = getConfigValue<string>('TERMS_OF_SERVICE_URL', '');

  return (
    <Box sx={{ maxWidth: 1, mx: 'auto' }}>
      <Typography
        component="p"
        variant="caption"
        sx={{
          color: 'text.secondary',
          my: 1,
        }}
      >
        By selecting the mobile number option, I agree to receive one-time SMS
        codes from Bright to review and approve my property listing before it is
        published.
      </Typography>
      <Typography
        component="p"
        variant="caption"
        sx={{
          color: 'text.secondary',
          my: 1,
        }}
      >
        Bright MLS listing review alerts via SMS. Msg & data rates may apply.
        Reply STOP to cancel, HELP for help. See our{' '}
        {getLink('Terms', termsLink)} and{' '}
        {getLink('Privacy Policy', privacyLink)}.
      </Typography>
    </Box>
  );
};

export default React.memo(DisclosureText);
